var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __classPrivateFieldSet = (this && this.__classPrivateFieldSet) || function (receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return (kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value)), value;
};
var __classPrivateFieldGet = (this && this.__classPrivateFieldGet) || function (receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var _PICCheckBox__tabIndex;
import { classMap } from 'lit/directives/class-map.js';
import { styleMap } from 'lit/directives/style-map.js';
import { property, query } from 'lit/decorators.js';
import { html, css } from 'lit';
import { customElement, arrayDecoder, booleanDecoder, stringDecoder, PICInput, PIC } from '../Internals';
let PICCheckBox = class PICCheckBox extends PICInput {
    setTabIndex(tabIndex) {
        if (tabIndex === 1 || tabIndex === true) {
            __classPrivateFieldSet(this, _PICCheckBox__tabIndex, 0, "f");
        }
        else if (tabIndex === -1 || tabIndex === false) {
            __classPrivateFieldSet(this, _PICCheckBox__tabIndex, -1, "f");
        }
        else {
            __classPrivateFieldSet(this, _PICCheckBox__tabIndex, tabIndex, "f");
        }
    }
    getTabIndex() {
        return __classPrivateFieldGet(this, _PICCheckBox__tabIndex, "f");
    }
    get indeterminate() {
        return this.inputField ? this.inputField.indeterminate : false;
    }
    get submitValue() {
        if (this.inputField) {
            if (this.mode_ === 'trillian') {
                return this.trillian;
            }
            else if (this.mode_ == 'linked' && this.isIndeterminate() || this.indeterminate)
                return 'indeterminate';
            else
                return this.inputField.checked.toString();
        }
        return this.value;
    }
    constructor() {
        super();
        this.horizontal_ = false;
        this.idLst_ = [];
        this.mode_ = 'regular';
        this.minFitContent = true;
        this.trillian = 'notchecked';
        _PICCheckBox__tabIndex.set(this, 0);
        this.isTableFilterSlider = false;
    }
    static get styles() {
        const defaultStyle = css `
        .pic-checkbox-old {
            width: 1rem;
            box-sizing: border-box;
            font-family: monospace;
            height: 1.35rem;
            margin-bottom: 1px;
            margin-top: 1px;
        }
        /*.checkbox-label:not(.inline){
            position: unset;
        }*/
        .groupcontainer{
            display: flex;
            justify-content: flex-start;
        }
        .horizontal {
            flex-direction: row;
        }
        .vertical {
            flex-direction: column;
        }
        .base{
            align-self: baseline;
        }
        :host{
            --pic-checkboxBGColor: var(--pic-surfaceColor);
            --pic-checkboxColor: var(--pic-primaryColor);
            --pic-checkboxHoverBGColor: var(--pic-primaryHoverColor);
            --pic-checkboxFocusBGColor: var(--pic-primaryFocusColor);
            --pic-checkboxActiveBGColor: var(--pic-primaryActiveColor);
            --pic-checkboxActiveColor: var(--pic-primaryColor);
            --pic-checkboxDisabledBGColor: var(--pic-primaryActiveColor);
            --pic-checkboxDisabledColor: var(--pic-disabledBGColor);
            --pic-checkboxDiabledBorderColor: var(--pic-blackOverlayFocusColor);
            --pic-checkboxOutlinedBorderColor: var(--pic-blackOverlayFocusColor);
            --pic-checkboxContainedBGColor: var(--pic-primaryColor);
            --pic-checkboxContainedColor: var(--pic-surfaceColor);
            --pic-checkboxContainedHoverBGColor: 
                linear-gradient(to right, var(--pic-whiteOverlayHoverColor), var(--pic-whiteOverlayHoverColor)),
                linear-gradient(to right, var(--pic-primaryColor), var(--pic-primaryColor));
            --pic-checkboxContainedFocusBGColor: 
                linear-gradient(to right, var(--pic-whiteOverlayFocusColor), var(--pic-whiteOverlayFocusColor)),
                linear-gradient(to right, var(--pic-primaryColor), var(--pic-primaryColor));
            --pic-checkboxContainedActiveBGColor: 
                linear-gradient(to right, var(--pic-whiteOverlayActiveColor), var(--pic-whiteOverlayActiveColor)),
                linear-gradient(to right, var(--pic-primaryColor), var(--pic-primaryColor));
            --pic-checkboxContainedDisabledBGColor: var(--pic-disabledBGColor);
            --pic-checkboxContainedDisabledColor: var(--pic-disabledColor);
            
            --pic-switchTrackColor: var(--pic-onSurfaceMediumColor);
            --pic-switchTrackCheckedColor: var(--pic-primaryMediumColor);
            --pic-switchThumbColor: var(--pic-primaryColor);
            --pic-switchHoverBGColor: var(--primaryHoverColor);
        }
        /* checkbox */
        .new.pic-checkbox-container {
            display: flex;
            align-items: center;
            justify-content: center;               
            position: absolute;
            border-radius: 50%;
            cursor: pointer;
        }
        .new.pic-checkbox-container.inline {
            display: flex;
            align-items: center;
            justify-content: center;
            align-items: center;
            border-radius: 50%;
            width: fit-content;
            cursor: pointer;
        }
        .inline .container.inline {
            position: relative;
        }
        .new.pic-checkbox-container.high{
            top: 5px;
            /* top: 2px; */
        }
        .new.pic-checkbox-container.medium{
            top: 14px;
        }
        .new.pic-checkbox-container.low{
            top: 18px;
        }
        .high .checkbox-label.pic-caption.pic-inputLabel-default{
            top: 0px;
            left: 2px;
        }
        .medium .checkbox-label.pic-caption.pic-inputLabel-default{
            top: 6px;
            left: 2px;
        }
        .low .checkbox-label.pic-caption.pic-inputLabel-default{
            top: 6px;
            left: 2px;
        }
        .pic-square::before {
                font-family: "Material Design Icons";
				content: '\u{F0131}';
            }
        .pic-square-check::before {
                font-family: "Material Design Icons";
				content: '\u{F0132}';
            }
        .pic-square-minus::before {
                font-family: "Material Design Icons";
				content: '\u{F0375}';
            }
        .new.pic-checkbox-container:hover{
            background-color: var(--pic-blackOverlayHoverColor);
        }
        .new.pic-checkbox-container:focus-within{
            outline: 0;
            background-color: var(--pic-blackOverlayHoverColor);
        }
        .pic-checkbox:disabled {
            background-color: var(--pic-checkboxDisabledColor);
        }
        .disabled {
            opacity: 0.5;
            pointer-events: none;
        }
        .disabled-lable {
            color: var(--pic-disabledColor);
            pointer-events: none;
        }
        .pic-checkbox-inline {
            width: 19px;
            height: 19px;
            font-size: 19px;
        }
        .pic-checkbox-low {
            width: 24px;
            height: 24px;
            font-size: 24px;
        }
        .pic-checkbox-medium {
            width: 21.33px;
            height: 21.33px;
            font-size: 21.33px;
        }
        .pic-checkbox-high {
            width: 18.67px;
            height: 18.67px;
            font-size: 18.67px;
        }

        /* switch */
        .pic-switch-container{
            display: flex;
            align-items: center;
            justify-content: center;
        }
        .switch-label{
            /*position: unset;*/
            /*position: relative;*/
            left: unset;
        }
        .switch-label.high{
            /*top: 5px;
            left: 1px;*/
        }
        .switch-label.medium{
            top: 6px;
            left: 4px;
        }
        .switch-label.low{
            top: 6px;
            left: 4px;
        }
        .switch-label.pic-inputLabel-default{
            width: unset;
        }
        .switch {
            position: relative;
            display: inline-block;
        }

        input.hide {
            position: absolute;
            opacity: 0;
            width: 0;
            height: 0;
        }
        .slider.disabled{
            pointer-events: none;
            background-color: var(--pic-disabledColor);
        }
        .slider {
            position: absolute;
            cursor: pointer;
            top: 0;
            left: 0;
            right: 0;
            bottom: 0;
            background-color: var(--pic-switchTrackColor);
            -webkit-transition: .4s;
            transition: .4s;
        }
        .slider:before {
            position: absolute;
            content: "";
            height: 18px;
            width: 18px;
            left: -7px;
            bottom: -5px;
            background-color: var(--pic-surfaceColor, white);
            -webkit-transition: .4s;
            transition: .4s;
            box-shadow: 0px 2px 2px rgba(0, 0, 0, 0.14), 0px 3px 1px rgba(0, 0, 0, 0.12), 0px 1px 5px rgba(0, 0, 0, 0.2);
        }
        .slider:hover :before{
            background-color: var(--pic-switchHoverBGColor);
            border-radius: 50%;
        }
        .low .slider {
            width: 34px;
            height: 14px;
            left: 10px;
            top: 18px;
        }
        .filter-slider-height .slider {
            top: 10px;
        }
        .low .slider:before{
            left: -4px;
            bottom: -2px;
        }
        .low input:checked+.slider:before {
            -webkit-transform: translateX(22px);
            -ms-transform: translateX(22px);
            transform: translateX(22px);
        }
        .medium .slider {
            width: 30px;
            height: 12px;
            left: 11px;
            top: 16px;
        }
        .medium .slider::before{
            left: -4px;
            bottom: -3px;
        }
        .medium input:checked+.slider:before {
            -webkit-transform: translateX(20px);
            -ms-transform: translateX(20px);
            transform: translateX(20px);
        }
        .high .slider {
            width: 26px;
            height: 8px;
            left: 12px;
            top: 12px;
        }
        .high .slider::before{
            left: -4px;
            bottom: -5px;
        }
        .high input:checked+.slider:before {
            -webkit-transform: translateX(16px);
            -ms-transform: translateX(16px);
            transform: translateX(16px);
        }
        .inline .slider {
            width: 26px;
            height: 8px;
            left: 6px;
            top: 3px;
        }
        .inline .slider::before{
            left: -9px;
            bottom: -3px;
        }
        input:checked+.slider:not(.disabled) {
            background-color: var(--pic-switchTrackCheckedColor);
        }

        input:focus+.slider {
            box-shadow: 0 0 1px #2196F3;
        }

        input:checked+.slider:before {
            background-color: var(--pic-switchThumbColor);
        }
        input:checked+.disabled.slider:before {
            background-color: var(--pic-primaryDisabledColor);
        }

        
        .horilabel.inline.checkbox-label.pic-caption.pic-inputLabel-default{
            top: 12px;
            left: 40px;
        }
        .horilabel.high.checkbox-label.pic-caption.pic-inputLabel-default{
            top: 12px;
            left: 40px;
        }
        .horilabel.medium.checkbox-label.pic-caption.pic-inputLabel-default{
            top: 27px;
            left: 40px;
        }
        .horilabel.low.checkbox-label.pic-caption.pic-inputLabel-default{
            top: 30px;
            left: 40px;
        }

        .inline input:checked+.slider:before {
            -webkit-transform: translateX(19px);
            -ms-transform: translateX(19px);
            transform: translateX(19px);
        }
        .container.inline{
            display: flex;
        }
        .slider.round {
            border-radius: 34px;
        }

        .slider.round:before {
            border-radius: 50%;
        }   

        .center{
            color: var(--pic-checkboxColor);
            text-align:center;
        }

        // Filter slider
        .filter-slider-height {
            height: 44px;
        }
        
        `;
        return css `
            ${super.styles}
            ${defaultStyle}
        `;
    }
    connectedCallback() {
        super.connectedCallback();
    }
    focus() {
        this.inputField.focus();
    }
    doNothing(e) {
        return false;
    }
    validate() {
        if (this.required_ && this.submitValue != 'true') {
            this.validState = [{ pass: false, failMessage: 'You must accept' }];
        }
        else {
            this.validState = [];
        }
    }
    setValue(value) {
        if (/^true$/i.test(value))
            this.setChecked(true);
        else if (this.mode_ === 'trillian' && /^indeterminate$/i.test(value))
            this.setTrillian('indeterminate');
        else
            this.setChecked(false);
    }
    changeHandler(e) {
        return super.changeHandler(e);
    }
    firstUpdated() {
        this.initValue_ = this.submitValue;
    }
    getCheckBoxStyle() {
        return {
            'pic-checkbox': this.eType !== 'old' && this.eType !== undefined,
            'pic-checkbox-old': this.eType == 'old' || this.eType == undefined,
            'pic-checkbox-inline': this.eType == 'default' && this.density == 'inline',
            'pic-checkbox-low': this.eType == 'default' && this.density == 'low',
            'pic-checkbox-medium': this.eType == 'default' && this.density == 'medium',
            'pic-checkbox-high': this.eType == 'default' && this.density == 'high',
            'disabled': this.disabled_
        };
    }
    getContainerStyle() {
        if (this.density === 'inline') {
            //remove padding when used in table
            if (this.closest('.grid-cell')) {
                return {
                    'padding': '0'
                };
            }
        }
        if (this.eType !== 'old')
            return {
                'padding': '10px'
            };
        return {};
    }
    getInnerContainerClassMap() {
        return {
            'container': true,
            'groupcontainer': true,
            'new': this.eType !== 'old',
            'pic-checkbox-container': ['default', 'old'].includes(this.eType),
            'pic-switch-container': this.eType == 'switch',
            'horizontal': this.horizontal_,
            'vertical': !this.horizontal_,
            'low': this.density == 'low',
            'medium': this.density == 'medium',
            'high': this.density == 'high',
            'inline': this.density == 'inline',
            'disabled': this.disabled_
        };
    }
    getSwitchClassMap() {
        return {
            'slider': true,
            'round': true,
            'disabled': this.disabled_
        };
    }
    getSwitchContainerClassMap() {
        return {
            'container': true,
            'low': this.density == 'low',
            'medium': this.density == 'medium',
            'high': this.density == 'high',
            'inline': this.density == 'inline',
        };
    }
    getInputLabelClass() {
        if (this.eType == 'switch')
            return Object.assign({ 'switch-label': true, }, super.getInputLabelClass());
        return Object.assign({ 'checkbox-label': true, }, super.getInputLabelClass());
    }
    getCheckIconMDIClass() {
        return {
            'pic-square': this.submitValue == 'false' || this.submitValue == 'notchecked' && !this.indeterminate,
            'pic-square-check': this.submitValue == 'true' || this.submitValue == 'checked' && !this.indeterminate,
            'pic-square-minus': this.submitValue == 'indeterminate',
            'pic-checkbox-inline': this.eType == 'default' && this.density == 'inline',
            'pic-checkbox-low': this.eType == 'default' && this.density == 'low',
            'pic-checkbox-medium': this.eType == 'default' && this.density == 'medium',
            'pic-checkbox-high': this.eType == 'default' && this.density == 'high',
            'center': true,
        };
    }
    getCheckIconClass() {
        return {
            'fa': true,
            'fa-solid': this.submitValue !== 'false' || this.indeterminate,
            'fa-regular': this.submitValue == 'false',
            'fa-square': this.submitValue == 'false' && !this.indeterminate,
            'fa-square-check': this.submitValue == 'true' && !this.indeterminate,
            'fa-square-minus': this.submitValue == 'indeterminate',
            'pic-checkbox-low': this.eType == 'default' && this.density == 'low',
            'pic-checkbox-medium': this.eType == 'default' && this.density == 'medium',
            'pic-checkbox-high': this.eType == 'default' && this.density == 'high',
            'center': true,
        };
    }
    getContainerClass() {
        var _a;
        if ((_a = this.parentElement) === null || _a === void 0 ? void 0 : _a.classList.contains('filterselectmenuitem')) {
            this.isTableFilterSlider = true;
            this.parentElement.style.setProperty('margin-top', '0');
        }
        return {
            'filter-slider-height': this.isTableFilterSlider
        };
    }
    getIcon() {
        if (this.submitValue == 'false' && !this.indeterminate)
            return this.fontAwesomeSVG.square.regular;
        else if (this.submitValue == 'true' && !this.indeterminate)
            return this.fontAwesomeSVG.squareCheck;
        else if (this.submitValue == 'indeterminate')
            return this.fontAwesomeSVG.squareMinus;
    }
    updated(_changedProperties) {
        super.updated(_changedProperties);
        if (this.mode_ == 'linked')
            this.checkIndeterminate();
    }
    isIndeterminate() {
        if (this.classList.contains('indeterminate'))
            return true;
        if (this.mode_ == 'linked') {
            if (this.idLst_.length > 0) {
                if (PIC.getInstance.findElementByIdDeep(this.idLst_[0])) {
                    let resM = new Map();
                    for (let idx = 0; idx < this.idLst_.length; idx++) {
                        resM.set(PIC.getInstance.findElementByIdDeep(this.idLst_[idx]).submitValue, 's');
                    }
                    return resM.size !== 1;
                }
            }
        }
        else if (this.mode_ == 'trillian') {
            return this.trillian === 'indeterminate';
        }
        return false;
    }
    checkIndeterminate() {
        if (this.idLst_.length > 0)
            if (PIC.getInstance.findElementByIdDeep(this.idLst_[0])) {
                let prev = PIC.getInstance.findElementByIdDeep(this.idLst_[0]).submitValue == 'true';
                let indeterm = false;
                for (let idx = 0; idx < this.idLst_.length; idx++) {
                    indeterm = (prev == (PIC.getInstance.findElementByIdDeep(this.idLst_[idx]).submitValue == 'true'));
                }
                this.inputField.indeterminate = indeterm;
            }
    }
    setChecked(iVal) {
        this.inputField.checked = iVal;
        this.requestUpdate();
    }
    setTrillian(iValue = 'notchecked') {
        // To set this with doTrillian you need to set it to the previous state i.e. to set checked then set it to notchecked
        switch (iValue) {
            case 'checked':
                this.trillian = 'notchecked';
                break;
            case 'notchecked':
                this.trillian = 'indeterminate';
                break;
            case 'indeterminate':
                this.trillian = 'checked';
                break;
        }
        this.doTrillian();
    }
    // This is meant to change the current state to a new state i.e checked becomes indeterminate   
    doTrillian() {
        switch (this.trillian) {
            case 'checked':
                this.trillian = 'indeterminate';
                this.inputField.checked = false;
                this.inputField.indeterminate = true;
                break;
            case 'notchecked':
                this.trillian = 'checked';
                this.inputField.checked = true;
                this.inputField.indeterminate = false;
                break;
            case 'indeterminate':
                this.trillian = 'notchecked';
                this.inputField.checked = false;
                this.inputField.indeterminate = false;
                break;
            default:
                break;
        }
        this.requestUpdate();
    }
    handleClick(e) {
        if (this.mode_ == 'linked') {
            if (this.idLst_) {
                for (let idx = 0; idx < this.idLst_.length; idx++) {
                    PIC.getInstance.findElementByIdDeep(this.idLst_[idx]).setChecked(this.inputField.checked);
                }
            }
        }
        else if (this.mode_ == 'trillian') {
            this.doTrillian();
        }
        else if (this.mode_ == 'regular') {
            this.validate();
            if (this.validState.length == 0) {
                this.changeHandler(e);
            }
        }
        else {
            console.error(this.mode_);
        }
        if (this.clickAction != null) {
            this.clickAction.triggerEvent(e);
        }
        else {
            this.requestUpdate();
        }
    }
    getOuterContainerStyle() {
        let styles = [];
        styles.push({ 'position': 'relative' });
        if (this.eType == 'old' && this.horizontal_) {
            styles.push({ 'display': 'flex' });
        }
        if (this.eType == 'default' && this.density == 'inline') {
            if (this.label && this.label.length > 0)
                styles.push({ 'padding-left': '5px' });
            else {
                styles.push({ 'display': 'flex' });
                styles.push({ 'justify-content': 'center' });
                styles.push({ 'align-items': 'center' });
                if (this.closest('.grid-cell') === null) { //remove padding when used in table
                    styles.push({ 'padding-left': '8px' });
                }
            }
        }
        if (this.density == 'old')
            styles.push({ 'height': 'calc(var(--pic-densityOldInputHeight) + var(--pic-densityOldLabelHeight))' });
        else if (this.density == 'inline') {
            styles.push({ 'padding': '0 5px 0 8px;' });
            styles.push({ 'width': 'fit-content' });
            styles.push({ 'display': 'flex' });
            styles.push({ 'justify-content': 'space-between' });
            styles.push({ 'align-items': 'center' });
        }
        else if (this.density == 'high')
            styles.push({ 'height': '36px' });
        else if (this.density == 'medium')
            styles.push({ 'height': '58px' });
        else
            styles.push({ 'height': '66px' });
        return styles.length > 0 ? styles.reduce((total, current) => total = Object.assign(Object.assign({}, total), current)) : {};
    }
    renderErr() {
        if (this.required_ && this.submitValue != 'true')
            return super.renderErr(this.showFullError);
        else
            return html ``;
    }
    render() {
        function renderLabel(iRef) {
            if (iRef.label && iRef.label.length > 0)
                return html `${iRef.renderCSS(true)}<label class=${classMap(iRef.classAdder(iRef.classAdder(iRef.getInputLabelClass(), ((iRef.horizontal_ && iRef.eType !== 'old') ? 'horilabel' : '')), iRef.density))} for=${iRef.id_ + '_inner'}>${iRef.label}</label>`;
            else
                return '';
        }
        this.setComponentInlineStyle(this.minFitContent ? 'fit-content' : undefined);
        if (['default', 'old'].includes(this.eType)) {
            //xmlprog3
            if (this.eType == 'default') {
                return html `
                    ${this.renderCSS(true)} 
                    <div style=${styleMap(this.getOuterContainerStyle())} tt class="${this.density}">
                        ${this.horizontal_ ? '' : renderLabel(this)}
                        <label 
                            style=${styleMap(this.getContainerStyle())} 
                            class=${classMap(this.getInnerContainerClassMap())}
                        >
                            <input
                                @click=${this.handleClick}
                                id=${this.id_}
                                type="checkbox" 
                                class="inner-input hide" 
                                tabindex=${this.disabled_ ? -1 : this.getTabIndex()}
                                name=${this.id_ + '_inner'}
                                ?disabled=${this.disabled_}
                                ?checked=${this.value == 'true'}
                                .indeterminate=${this.isIndeterminate()}
                                />
                            <div class=${classMap(this.getCheckIconMDIClass())}></div>
                            <!-- ${this.getIcon()} -->
                        </label>
                        ${this.horizontal_ ? renderLabel(this) : ''}
                        ${this.renderErr()}
                    </div>
                    ${this.tooltip_ ? html `<pic-tooltip>${this.tooltip_}</pic-tooltip>` : ''}
                `;
            }
            //xmlprog2
            else {
                return html `
                ${this.renderCSS(true)} 
                <div class="groupcontainer ${this.horizontal_ ? 'horizontal' : 'vertical'}" style=${styleMap(this.getOuterContainerStyle())} tt>
                    ${renderLabel(this)}
                    <input 
                        id=${this.id_}
                        type="checkbox" 
                        class="inner-input base" 
                        name=${this.id_ + '_inner'}
                        ?disabled=${this.disabled_}
                        ?checked=${this.value == 'true'}       
                        @click=${this.handleClick}
                        tabindex=${this.getTabIndex()}
                        />                    
                    ${this.renderErr()}
                </div>
                ${this.tooltip_ ? html `<pic-tooltip>${this.tooltip_}</pic-tooltip>` : ''}
            `;
            }
        }
        else {
            //slider
            return html `
                ${this.renderCSS(true)}
                <div class=${classMap(this.getContainerClass())} style="height:${this.density == 'high' ? '36px;' : this.density == 'medium' ? '58px;' : '66px;'}">
                    <div style="position:relative; ${this.eType == 'old' && this.horizontal_ ? 'display:flex;' : ''}" class=${classMap(this.getSwitchContainerClassMap())} tt>
                        ${this.horizontal_ ? '' : renderLabel(this)}
                        <label class="switch" style="display:flex;align-items:center;justify-content:center;">
                            <input 
                            id=${this.id_ + '_inner'} 
                            type="checkbox" 
                            class="inner-input hide"
                            ?disabled=${this.disabled_}
                            ?checked=${this.value == 'true'}
                            @click=${this.handleClick}
                            @keydown=${this.enterSubmit}
                            tabindex=${-1}
                            >
                            <span tabindex=${this.disabled_ ? -1 : this.getTabIndex()} class=${classMap(this.getSwitchClassMap())} @keydown=${(e) => {
                var _a, _b;
                if (e.key === ' ' || e.key === 'Enter' || e.key === 'NumpadEnter') {
                    (_b = (_a = this.shadowRoot) === null || _a === void 0 ? void 0 : _a.querySelector(`#${this.id_}_inner`)) === null || _b === void 0 ? void 0 : _b.click();
                }
            }}></span>
                        </label>
                        ${this.horizontal_ ? renderLabel(this) : ''}
                        ${this.renderErr()}
                    </div>
                </div>
                ${this.tooltip_ ? html `<pic-tooltip>${this.tooltip_}</pic-tooltip>` : ''}
                `;
        }
    }
};
_PICCheckBox__tabIndex = new WeakMap();
__decorate([
    query('.inner-input')
], PICCheckBox.prototype, "inputField", void 0);
__decorate([
    property({ reflect: true, attribute: 'horizontal', converter: booleanDecoder })
], PICCheckBox.prototype, "horizontal_", void 0);
__decorate([
    property({ reflect: true, attribute: 'idlst', converter: arrayDecoder })
], PICCheckBox.prototype, "idLst_", void 0);
__decorate([
    property({ reflect: true, attribute: 'mode', converter: stringDecoder })
], PICCheckBox.prototype, "mode_", void 0);
PICCheckBox = __decorate([
    customElement('pic-checkbox')
], PICCheckBox);
export { PICCheckBox };
//# sourceMappingURL=PICCheckBox.js.map